module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": "",
      "fill-height": ""
    }
  }, [_c('v-layout', [_c('v-flex', {
    attrs: {
      "sm8": "",
      "offset-sm2": ""
    }
  }, [_c('v-card', [_c('v-chip', {
    staticClass: "purple darken-3 white--text",
    attrs: {
      "label": ""
    }
  }, [_vm._v("\n          " + _vm._s(_vm.channelName) + "\n        ")]), _vm._v(" "), _c('transition-group', {
    attrs: {
      "tag": "div",
      "name": "list"
    }
  }, _vm._l((_vm.messages), function(message) {
    return _c('single-message', {
      key: message.id,
      attrs: {
        "message": message
      }
    })
  }))], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "message_container"
  }, [_c('div', {
    staticClass: "centered mb-2"
  }, [_c('message-form')], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f43a978e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/messages/Messages.vue
// module id = 227
// module chunks = 1